import React, { useEffect, useState } from 'react'

//Import AOS
import AOS from "aos";
import "aos/dist/aos.css";

const ContactForm = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState(''); 

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({name, email, phone, subject, message});
    
  };

    useEffect(() => {
                AOS.init({
                  duration: 1000, // Animation duration in milliseconds
                  once: false,
                  offset: 100,  // Trigger when the element is 100px from the viewport
              delay: 200, // Whether animation should happen only once
                });
}, []);

  return (
    <div id='gps' className='my-12 lg:my-20'>
        {/* Contact Form Heading */}
        <div className='text-center' data-aos="fade-down">
            <h1 className='text-[#252525] font-bold text-2xl md:text-4xl xl:text-5xl oxygen'>
              Send us Message
            </h1>
            <p className='text-[#868686] text-sm md:text-base lg:text-lg xl:text-xl px-6 md:px-12 lg:px-36 xl:px-48 my-4 md:my-8'>
                Sed ut perspiciatis unde omnis natus errorsit voluptatem accusantium doloremque laudantium aperiam eaque quae abillo inventore veritatis quasi architecto beatae vitae dicta sunt explicabo
            </p>
        </div>

        {/* Contact Form */}
        <div className='mx-4 md:mx-8 lg:mx-auto lg:w-2/3'>
            <form className='grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-10 mt-12'>
                <input type="text" placeholder='Your Name' required
                  className='bg-[#FBF8FF] p-4 rounded-lg text-sm md:text-base lg:text-lg focus:outline-[#214293]' 
                  value={name}
                  onChange={(e) => setName(e.target.value)}/>
                <input type="tel" placeholder='Phone Number' required
                  className='bg-[#FBF8FF] p-4 rounded-lg text-sm md:text-base lg:text-lg focus:outline-[#214293]' 
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}/>
                <input type="email" placeholder='Email Id' required
                  className='bg-[#FBF8FF] p-4 rounded-lg text-sm md:text-base lg:text-lg focus:outline-[#214293]' 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}/>
                <input type="text" placeholder='Subject' required
                  className='bg-[#FBF8FF] p-4 rounded-lg text-sm md:text-base lg:text-lg focus:outline-[#214293]' 
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}/>
                <textarea placeholder='Message' required
                  className='bg-[#FBF8FF] p-4 rounded-lg text-sm md:text-base lg:text-lg focus:outline-[#214293] col-span-2' 
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}/>
                <button type='submit' 
                  className='bg-[#F26422] text-white p-3 rounded-lg text-sm md:text-base lg:text-lg hover:bg-[#F22F00] md:w-1/5 mx-auto col-span-2'
                  onClick={handleSubmit}>
                  Submit
                </button>
            </form>
        </div>
    </div>
  )
}

export default ContactForm